var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapleLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#113B5B",
    d: "M32 3l5 16.5L52 10l-7 17 16 2.5-15 8L55 52l-17-5-1 13-1-13-17 5 9-14.5-15-8L19 27 12 10l15 9.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 24,
    x2: 32,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 32,
    x2: 40,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 32,
    x2: 25,
    y2: 38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 32,
    x2: 39,
    y2: 38
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 38.5,
    rx: 2.5,
    ry: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39,
    cy: 38.5,
    rx: 2.5,
    ry: 1,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapleLeaf);
export default __webpack_public_path__ + "static/media/maple-leaf.9c78048b0540345a6388591a76c07712.svg";
export { ForwardRef as ReactComponent };